

















import { RecurrenceInterventionApi } from "../api/RecurrenceInterventionApi";
import RemplacementAlertsModal from "./RemplacementAlertsModal.vue";

export default {
    name: "RemplacementAlerts",
    components: { RemplacementAlertsModal },
    data() {
        return {
            alerts: [],
            RecurrenceInterventionApi: new RecurrenceInterventionApi(),
            showModal: false,
        };
    },
    created() {
        let self = this;
        this.RecurrenceInterventionApi.getAlerts().then(function (res) {
            self.alerts = res;
        });
    },
    methods: {
        openModal: function () {
            this.showModal = true;
        },
        closeModal: function () {
            this.showModal = false;
        },
    },
};
